var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuyerBenefits3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.66 56.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.78,3.86c11.81-3.48,21.16,4.67,21.56,5a1.5,1.5,0,0,0,2-2.24C42.88,6.24,32.32-3,18.94,1,8.47,4.06,3.92,12.75,2.78,15.34a1.5,1.5,0,0,0,.76,2,1.46,1.46,0,0,0,.5.12,1.49,1.49,0,0,0,1.48-.89C6.24,14.92,10.31,6.64,19.78,3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.46,23.38A24.46,24.46,0,0,0,49,13.68,1.5,1.5,0,0,0,47,13.19a1.49,1.49,0,0,0-.49,2.06A21.37,21.37,0,0,1,48.4,33.68a1.5,1.5,0,0,0,.91,1.92,1.36,1.36,0,0,0,.39.08,1.5,1.5,0,0,0,1.53-1A24.58,24.58,0,0,0,52.46,23.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.07,12.28c-6-4.64-13.65-3.71-16.67-3.09a1.5,1.5,0,0,0,.6,2.94c2.62-.54,9.24-1.36,14.23,2.52,5.7,4.45,5.88,12.47,6,17.78A36.24,36.24,0,0,1,39,45.72a1.5,1.5,0,0,0,.9,1.92,1.44,1.44,0,0,0,.4.09,1.5,1.5,0,0,0,1.52-1,39.19,39.19,0,0,0,2.41-14.39C44.11,26.84,43.9,17.6,37.07,12.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.93,40.86a1.49,1.49,0,0,0-1.67,1.31l-.9,7.28a1.49,1.49,0,0,0,1.31,1.67h.07a1.5,1.5,0,0,0,1.6-1.31l.9-7.29A1.5,1.5,0,0,0,32.93,40.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.4,16.93c-2.14-1-4.76-1-7.79,0-6.45,2.16-6.78,9.49-7.13,17.26-.12,2.65-.25,5.39-.62,8a1.5,1.5,0,0,0,1.28,1.69h.1a1.49,1.49,0,0,0,1.59-1.28c.39-2.75.52-5.57.64-8.29.32-7,.59-13,5.09-14.54,2.27-.76,4.13-.8,5.54-.12,3.65,1.76,3.73,5.87,3.43,11.94-.05.89-.09,1.77-.11,2.63a1.5,1.5,0,1,0,3,.07c0-.83.06-1.69.1-2.55C35.8,26.09,36.12,19.69,30.4,16.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.06,14.79a1.49,1.49,0,0,0-2.11.13,19.78,19.78,0,0,0-4,6.84,22,22,0,0,0-.93,7c0,1.36-.07,2.91-.23,4.87a64.75,64.75,0,0,1-1.16,7.82,1.49,1.49,0,0,0,1.16,1.77.64.64,0,0,0,.2,0A1.5,1.5,0,0,0,9.6,42.07a66.61,66.61,0,0,0,1.21-8.19c.17-2.05.21-3.65.24-5.06a18.86,18.86,0,0,1,.78-6.12,16.68,16.68,0,0,1,3.37-5.8A1.48,1.48,0,0,0,15.06,14.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3,27.09a26.06,26.06,0,0,1,.09-3.75A1.5,1.5,0,0,0,1.78,21.7,1.48,1.48,0,0,0,.14,23.05,27.87,27.87,0,0,0,0,27.24,28.34,28.34,0,0,0,.68,32,1.51,1.51,0,0,0,2,33.18a1.63,1.63,0,0,0,.44,0,1.5,1.5,0,0,0,1.14-1.79A25.64,25.64,0,0,1,3,27.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.44,27.15a1.5,1.5,0,1,0-3-.23L23,46.55a4.62,4.62,0,0,0-1.41-.11,6.88,6.88,0,0,0-6,5.23c-.49,2.66,1.38,4.63,4.19,4.4a6.88,6.88,0,0,0,6-5.22,4.4,4.4,0,0,0,0-1.45Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyerBenefits3);
export default __webpack_public_path__ + "static/media/buyer_benefits_3.ad08e20692627966f86c3c9c620f0ec2.svg";
export { ForwardRef as ReactComponent };